import React from 'react'
import BoundaryError from 'common/components/BoundaryError'
import NavBar from 'common/components/NavBar'
import { Outlet, useLocation, useParams } from 'react-router'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'

const InstanceApp = ({

}) => {
    const { id } = useParams()
    const { pathname } = useLocation()

    const {
        data: instance,
        reload: reloadInstance,
    } = useFetch(ApplicationConf.instance.single(id))

    const links = [
        { icon: 'dashboard', tooltip: 'Dashboard', url: `/instance/${id}/dashboard` },
        { icon: 'compare_arrows', tooltip: 'Description', url: `/instance/${id}/description` },
        { icon: 'rule', tooltip: 'Licence', url: `/instance/${id}/license` },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet context={{ instance, reloadInstance }} />
                </div>
            </BoundaryError>
        </>
    )
}

export default InstanceApp